import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Constants from "../../services/constant";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { useHistory } from "react-router-dom";
import { getData, postData, postData1, putData, putData1 } from "../../services/http.service";
import { InputTextarea } from "primereact/inputtextarea";
import Cross from "../../assets/demo/flags/cross.png";
import moment from "moment/moment";
import { Image } from "primereact/image";
import profile from "../../assets/demo/flags/profile.png";
import { Chips } from "primereact/chips";
import species_dummy from "../../assets/demo/flags/species_dummy.svg";
import point_marker_dummy from "../../assets/demo/flags/point-marker-dummy.svg";

const PointMarkerEdit = () => {
    const { id } = useParams();
    const toast = useRef(null);
    const history = useHistory();



 
   const [pointMarkerImg,setPointMarkerImg] = useState(null)
    const [PointMarkerInfo, setPointMarkerInfo] = useState({
        markerName:"",
        type:'',
    });

    const [err, setErr] = useState({});
    const [loading, setLoading] = useState(true);

    console.log("PointMarkerInfo",PointMarkerInfo)

const PointTypes = [
    {
    name:'Way Point',
    value:'WAYPOINT'
},
{
    name:'Hit Point',
    value:'HITPOINT'
},
]

    console.log("err", err);

    const onChange = (e) => {
        const {name,value} = e.target
        setPointMarkerInfo((prev)=>{
            return {
                ...prev,
                [name]: value
            }
        })
        setErr({ ...err, [name]: "" })
    }

    const validateForm = () => {
        let errors = {};
        if (!PointMarkerInfo.markerName) {
            errors.markerName = "Point Marker Name is required";
        }
        if (!PointMarkerInfo.type) {
            errors.type = "Point Marker Type is required";
        }
        if (!pointMarkerImg) {
            errors.pointMarkerImage = "Point Marker Image is required";
        }

        setErr(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = validateForm();
        if (form) {
            const formData = new FormData();
            // formData.append("markerImage", pointMarkerImg);
            formData.append("markerName", PointMarkerInfo.markerName);
            formData.append("type", PointMarkerInfo.type);
            if(pointMarkerImg!==null){
                formData.append("markerImage", pointMarkerImg);
            }
            else{
                formData.append("markerImage", PointMarkerInfo.markerImage);
            }
            putData1(Constants.END_POINT.UPDATE_POINT_MARKER + id, formData)
                .then((res) => {
                    if (res.success) {
                        toast.current.show({ severity: "info", summary: "", detail: "Point Marker has been Updated Succesfully", life: 3000 });
                                    setTimeout(()=>history.push("/point-marker"), 1000)
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            window.scrollTo({
                top: 250,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        getSinglePointMarker();
    }, []);

    const getSinglePointMarker = () => {
        getData(Constants.END_POINT.EDIT_POINT_MARKER + id)
            .then((res) => {
                if (res.success) {
                    let obj = {
                        markerName:res.data.markerName,
                        type:res.data.type,
                        markerImage:res.data.markerImage
                    }
                    setPointMarkerInfo(obj)
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };




    return (
        <div className="grid">
            <div className="col-12 md:col-12 mx-auto">
                <Toast ref={toast} />
                <div className="card ">
                {loading ? 
                    <div className="overlay-loading">
                    <div class="spinner-border text-dark" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                : null}
                    <div className=" flex justify-content-center">
                        <h3>Edit Point Marker</h3>
                        <div className="ml-4 align-right"></div>
                    </div>
                    {/* <img src={product} alt="" width="10%" style={{ display: "block", marginLeft: "auto", marginRight: "auto" }} /> */}
                    <div className="p-fluid grid">
                        <div className="field col-12 md:col-12">
                            <div className="weapon-image-wrapper mt-4">
                                <div className="weapon-image-div">
                                    <img src={pointMarkerImg ? URL.createObjectURL(pointMarkerImg) : PointMarkerInfo.markerImage!=="" ? Constants.BASE_URL + PointMarkerInfo.markerImage  : point_marker_dummy} alt="" className="weaponImageTag" />
                                    {pointMarkerImg!==null ?
                                    <div className="weapon-edit-div">
                                        <i onClick={()=>setPointMarkerImg(null)}  className="fa-sharp fa-solid fa-trash delete"></i>
                                    </div>
                                    : null }
                                </div>

                                <input
                                    type="file"
                                    id="pointMarkerImage"
                                    name="pointMarkerImage"
                                    onChange={(e) => {
                                        setPointMarkerImg(e.target.files[0]);
                                        setErr({ ...err, pointMarkerImage: "" });
                                    }}
                                    onClick={(event)=> { 
                                        event.currentTarget.value = null
                                   }}
                                    hidden
                                />
                                <label htmlFor="pointMarkerImage" className="weaponImageLabel">
                                    Edit Point Marker Image
                                </label>
                                <div className="text-danger">{err.pointMarkerImage}</div>
                            </div>
                            {/* <div className="text-danger">{err.speciesName}</div> */}
                        </div>
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label mt-4">
                                <InputText id="markerName" name="markerName" onChange={onChange} value={PointMarkerInfo.markerName} />
                                <label htmlFor="markerName">Point Marker Name</label>
                            </span>
                            <div className="text-danger">{err.markerName}</div>
                        </div>
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label mt-4">
                            <Dropdown id="type" name="type" onChange={onChange} value={PointMarkerInfo.type} options={PointTypes} optionLabel="name" className="w-full" />
                                {/* <InputText id="type" name="type" onChange={onChange} value={PointMarkerInfo.type} /> */}
                                <label htmlFor="type">Type</label>
                            </span>
                            <div className="text-danger">{err.type}</div>
                        </div>
                        
                       
                    </div>
         

                    <div className="flex justify-content-left mt-3 ">
                        {
                            <Button type="button" className="p-button-md p-button-success" onClick={handleSubmit}>
                                Update Point Marker
                            </Button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PointMarkerEdit;
